import { TranslateService } from '@ngx-translate/core';
import { NgModule, Sanitizer } from '@angular/core';
import { JhiAlertService, JhiConfigService } from 'ng-jhipster';

import {
    FindLanguageFromKeyPipe,
    JhiAlertComponent,
    JhiAlertErrorComponent,
    JhiLanguageHelper,
    PlatonSharedLibsModule,
} from './';

export function alertServiceProvider(
    sanitizer: Sanitizer,
    translateService: TranslateService
) {
    // HACK: this needs to be the same as in shared-libs.module.ts,
    // otherwise this takes precedence and options specified there.
    // I don't know why.
    let config = new JhiConfigService({
        alertAsToast: true,
        i18nEnabled: true,
        defaultI18nLang: 'fr',
    });
    return new JhiAlertService(sanitizer, config, translateService);
}

@NgModule({
    imports: [PlatonSharedLibsModule],
    declarations: [
        FindLanguageFromKeyPipe,
        JhiAlertComponent,
        JhiAlertErrorComponent,
    ],
    providers: [
        JhiLanguageHelper,
        {
            provide: JhiAlertService,
            useFactory: alertServiceProvider,
            deps: [Sanitizer, TranslateService],
        },
    ],
    exports: [
        PlatonSharedLibsModule,
        FindLanguageFromKeyPipe,
        JhiAlertComponent,
        JhiAlertErrorComponent,
    ],
})
export class PlatonSharedCommonModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared-common.module.ts